import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class InsertTokenState extends BaseYcState {
  readonly tokenToInsert: string;
}
